import axios from '@/lib/axios'

import type { User } from '@/modules/users/interfaces/user'

interface AssignParams {
	userId: number
	departmentId: number | undefined
	costCenterId: number
}

/**
 * Asigna centro de costo a un usuario recién creado.
 *
 * Existe porque `POST /api/companies/{company}/users` NO acepta
 * `cost_center_id`: `StoreUserRequest` no lo valida y Laravel lo descarta.
 * `UpdateUserRequest` sí lo acepta, así que el alta con centro de costo son dos
 * llamadas: crear y luego actualizar.
 *
 * Se manda también `departmentId` porque la regla del backend valida el centro
 * contra el departamento del PAYLOAD (`$this->input('department_id', …)`), no
 * solo contra el que ya tenga guardado el usuario.
 *
 * No usa `useUser().updateUserAsync` a propósito: ese lanza un toast de
 * "Usuario actualizado con éxito" que, pegado al de "Usuario creado", se lee
 * como si hubieran pasado dos cosas distintas.
 *
 * Puede fallar con 403 y es esperable: `UpdateUserRequest::authorize()` exige
 * `update-users` sobre la empresa, y quien tiene `create-users` no siempre lo
 * tiene. El caller decide qué decirle a la persona; lo que no puede es dar el
 * alta por incompleta, porque el usuario ya quedó creado.
 */
export const assignCostCenter = async ({
	userId,
	departmentId,
	costCenterId,
}: AssignParams): Promise<User> => {
	const { data } = await axios.put<User>(`/api/users/${userId}`, {
		departmentId,
		costCenterId,
	})

	return data
}

export default assignCostCenter
